import { defineMessages } from 'react-intl';

export const consentStepMessages = defineMessages({
    consent: {
        id: 'consent.button.consent',
        defaultMessage: 'I Consent',
        description: 'Button to consent to the terms',
    },
    accept: {
        id: 'consent.button.accept',
        defaultMessage: 'I Accept',
        description: 'Button to accept the terms',
    },
    consentHeading: {
        id: 'consent.heading.consent',
        defaultMessage: 'Consent',
        description: 'Header for a consent terms type',
    },
    authorizationHeading: {
        id: 'consent.heading.authorization',
        defaultMessage: 'Authorization',
        description: 'Header for an authorization terms type',
    },
    parentalConsentHeading: {
        id: 'consent.title.parental',
        defaultMessage: 'Parent/Guardian Consent',
        description: 'Name of the Parent/Guardian consent section',
    },
    consentDialogTitle: {
        id: 'consent.dialog.title',
        defaultMessage: 'Consent is required to access Calm Health.',
        description:
            'Explanation of why the user needs to consent to access Calm Health.',
    },
    consentDialogContent: {
        id: 'consent.dialog.content',
        defaultMessage:
            'To receive the limited experience, you need to allow Calm Health to collect certain personal health data, when necessary.',
        description: 'Explanation of why consent is needed',
    },
    sponsoredConsentTitle: {
        id: 'consent.title.sponsor',
        defaultMessage: '{name} Consent',
        description: 'Name section of the consent with the sponsors name',
    },
    consentTitle: {
        id: 'consent.title.noSponsor',
        defaultMessage: 'Your Calm Health Sponsor',
        description: 'Label for the sponsor of a user',
    },
    chdppSrTitle: {
        id: 'consent.srTitle.chdpp',
        defaultMessage: 'Consent to Collect Consumer Health Data',
        description: 'Consent title for chdpp',
    },
    ginaSrTitle: {
        id: 'consent.srTitle.gina',
        defaultMessage: 'Partner Authorization',
        description: 'Consent title for chdpp',
    },
});

export default consentStepMessages;
